import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import { FaArrowRight } from "react-icons/fa6";
import { motion } from "framer-motion";


const PhotographyShowcase = () => {
  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.3, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.3, ease: "easeOut" },
  },
};

  return (
    <div className="overflow-x-hidden">
    <Header />
    <div className="w-full bg-white py-28">
        {/* 1 */}
      {/* <div className="max-w-7xl mx-auto px-6 mb-14"> */}
        <motion.div
                      variants={fadeLeft}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      className="max-w-7xl mx-auto px-6 mb-14"
                    >
        <div className="max-w-xl">
          <span className="bodyFont inline-block bg-gray-200 text-gray-700 text-sm px-4 py-1 rounded-full mb-5">
            Photography & Cinematography
          </span>

          <h1 className="montserrat text-4xl md:text-5xl font-light leading-tight mb-6">
            Shaping the Future <br /> of Architecture
          </h1>

          <p className="montserrat text-gray-500 text-base leading-relaxed">
            Our award-winning studio merges creativity, sustainability, and functionality to create spaces that inspire and endure.
             Discover how we transform your architectural vision into reality, one detail at a time.
          </p>
        </div>
        </motion.div>
      {/* </div> */}
        {/* 2 */}
      <div className="w-full">
        <img
          src="https://www.sustainableplaces.eu/wp-content/uploads/2017/02/SmartBuilding.jpg"
          alt="Architecture Showcase"
          className="w-full h-[420px] md:h-[620px] object-cover"
        />
      </div>
      {/* <motion.div
        initial={{ opacity: 0, scale: 1.2 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="w-full overflow-hidden"
      >
        <img
          src="https://www.sustainableplaces.eu/wp-content/uploads/2017/02/SmartBuilding.jpg"
          alt="Architecture Showcase"
          className="w-full h-[420px] md:h-[620px] object-cover"
        />
      </motion.div> */}

        {/* 3 */}
       <div className="grid grid-cols-1 md:grid-cols-2 items-center mt-8">
            <motion.div
                      variants={fadeLeft}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      className="max-w-7xl mx-auto lg:px-14 px-5"
                    >
            {/* <div className="max-w-7xl mx-auto lg:px-14 px-5"> */}
            <h2 className="montserrat text-3xl md:text-4xl font-light leading-tight mb-6">
                We bring innovation, <br className="hidden lg:block"/>
                elegance, and <br className="hidden lg:block"/>
                creativity together
            </h2>

            <p className="montserrat text-gray-500 text-base leading-relaxed mb-8 max-w-md">
                With a legacy of excellence in architecture, our designs are not just structures—they are experiences.
                In every project, we take pride in creating spaces that inspire, adapt, and endure.
            </p>

            <button className="flex items-center gap-2 border border-black px-6 py-3 text-md montserrat hover:bg-black hover:text-white transition">
                DISCOVER MORE <FaArrowRight />
            </button>
            {/* </div> */}
            </motion.div>

            {/* <div className="w-full h-[420px] md:h-[520px] mt-3 hidden md:block"> */}
            <motion.div
                        variants={fadeRight}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="w-full h-[420px] md:h-[520px] mt-3 hidden md:block"
                      >
            <img
                src="https://maag.codesupply.co/design-architecture/wp-content/uploads/sites/4/2024/04/demo-image-0016-1400x788.webp"
                alt="Modern Architecture"
                className="w-full h-full object-cover"
            />
            </motion.div>
            {/* </div> */}
        </div>
            {/* 4 */}
        {/* <div className="w-full mt-10">
        <img
          src="https://maag.codesupply.co/design-architecture/wp-content/uploads/sites/4/2024/04/demo-image-0016-1400x788.webp"
          alt="Architecture Showcase"
          className="w-full h-[420px] md:h-[620px] object-cover"
        />
        </div> */}
          <img
            src="https://maag.codesupply.co/design-architecture/wp-content/uploads/sites/4/2024/04/demo-image-0016-1400x788.webp"
            alt="Architecture Showcase"
            className="w-full h-[420px] md:h-[620px] object-cover"
          />


        {/* 5 */}
        <div className="w-full bg-white py-24">
        <div className="max-w-7xl mx-auto px-6">

            <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-14">
            <h2 className="montserrat text-xl text-black">
                See our last projects
            </h2>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-10"> */}
                <motion.div
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            className="grid grid-cols-1 md:grid-cols-3 gap-10"
                          >
            <div>
                <img
                src="https://miro.medium.com/0*cAPi7knrUArAJFC3"
                alt="The Horizon Tower"
                className="w-full h-[260px] object-cover mb-4"
                />

                <h3 className="montserrat font-bold text-black">
                The Horizon Tower
                </h3>

                <p className="montserrat text-sm text-black mt-1">
                2023
                </p>

                <a
                href="/"
                className="montserrat text-md inline-flex items-center gap-1 mt-3 hover:underline"
                >
                View more <FaArrowRight />
                </a>
            </div>

            <div>
                <img
                src="https://miro.medium.com/0*cAPi7knrUArAJFC3"
                alt="The Horizon Tower"
                className="w-full h-[260px] object-cover mb-4"
                />

                <h3 className="montserrat font-bold text-black">
                The Horizon Tower
                </h3>

                <p className="montserrat text-sm text-black mt-1">
                2023
                </p>

                <a
                href="/"
                className="montserrat text-md inline-flex items-center gap-1 mt-3 hover:underline"
                >
                View more <FaArrowRight />
                </a>
            </div>

            <div>
                <img
                src="https://cdn.prod.website-files.com/660d7bd356826597be57e4c6/660d7bd356826597be57e55e_Thumbnail_Realestatoe_2.jpg"
                alt="Urban Oasis Pavilion"
                className="w-full h-[260px] object-cover mb-4"
                />
                <h3 className="montserrat font-bold text-black">
                Urban Oasis Pavilion
                </h3>

                <p className="montserrat text-sm text-black mt-1">
                2021
                </p>

                <a
                href="/"
                className="montserrat text-md inline-flex items-center gap-1 mt-3 hover:underline"
                >
                View more <FaArrowRight />
                </a>
            </div>
            </motion.div>
            {/* </div> */}

            <div className="mt-16">
             <a href="/">   
            <button className="flex items-center gap-2 montserrat text-md border-b border-black pb-1 hover:opacity-70 transition">
                VIEW ALL PROJECTS <FaArrowRight />
            </button>
            </a>
            </div>

        </div>
        </div>
        </div>
            <LetsGet />
            <FollowUs />  
            <Footer />

    </div>
  );
};

export default PhotographyShowcase;
